<div class="h-100 d-flex flex-column justify-content-between">
  <div class="search-container">
    <input
      type="text"
      placeholder="Search here"
      class="search-input"
      [(ngModel)]="searchQuery"
      (input)="onSearchInputChange(searchQuery)"
    />
  </div>
  <div class="list-container">
    <div *ngIf="filteredListOfValues.length > 0; else noResults">
      <div *ngFor="let value of filteredListOfValues" class="list-item">
        <input
          type="checkbox"
          class="input-checkbox"
          [checked]="isChecked(value)"
          (change)="onCheckboxChange(value, $event)"
        />
        <p class="item-value">{{ value.key }}</p> <!-- Only show the key -->
      </div>
    </div>
    <ng-template #noResults>
      <p class="no-results">No results found</p>
    </ng-template>
  </div>
  <div class="footer-container d-flex justify-content-end">
    <ion-button class="clear-btn" (click)="clearCheckedValues()">
      <ion-icon name="close-outline"></ion-icon>
      <ion-text>Clear</ion-text>
    </ion-button>
  </div>
</div>
